// this configuration use for theme dark and light for tailwindcss
// you can use this for personal project or others without libs download

export const setDarkMode = (toggle) => {
  if (localStorage.getItem("color-theme")) {
    if (toggle) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("color-theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("color-theme", "light");
    }
    // if NOT set via local storage previously
  } else {
    if (document.documentElement.classList.contains("light")) {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("color-theme", "light");
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("color-theme", "dark");
    }
  }
};

export const loadDarkMode = () => {
  const isDark = localStorage.getItem("color-theme") == "dark" ? true : false;

  if (localStorage.getItem("color-theme")) {
    if (localStorage.getItem("color-theme") === "dark") {
      document.documentElement.classList.add("dark");
      localStorage.setItem("color-theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("color-theme", "light");
    }
    // if NOT set via local storage previously
  } else {
    document.documentElement.classList.remove("dark");
    localStorage.setItem("color-theme", "light");

  }

  return isDark;
};
